import React, { useState } from 'react';
import { upsertLead } from '../lib/firebase';

function parsePastedText(raw) {
  const leads = [];
  const blocks = raw.trim().split(/\n{2,}/);

  for (const block of blocks) {
    const lines = block.split('\n').map(l => l.trim()).filter(Boolean);
    if (lines.length < 1) continue;

    const lead = { source: 'import' };
    lead.businessName = lines[0];

    for (const line of lines.slice(1)) {
      if (/^(\+61|0)[2-9]\d{7,9}$/.test(line.replace(/\s/g, ''))) {
        lead.phone = line;
      } else if (/^https?:\/\/|^www\./i.test(line)) {
        lead.website = line.startsWith('http') ? line : `https://${line}`;
      } else if (/^\d\.\d/.test(line)) {
        const m = line.match(/^(\d\.\d+)\s*\(?(\d+)?/);
        if (m) { lead.rating = parseFloat(m[1]); if (m[2]) lead.reviewCount = parseInt(m[2]); }
      } else if (/\d+.*(?:St|Rd|Ave|Dr|Ln|Blvd|Ct|Pl|Way|Hwy|Pde|Cres)/i.test(line)) {
        lead.address = line;
        const parts = line.split(',');
        if (parts.length > 1) lead.suburb = parts[parts.length - 1].trim().replace(/\s+NSW.*|VIC.*|QLD.*|WA.*|SA.*|TAS.*|ACT.*/i, '').trim();
      } else if (line.length < 40 && !/\d/.test(line) && !lead.category) {
        lead.category = line;
      }
    }

    if (lead.businessName) leads.push(lead);
  }

  return leads;
}

export default function Import() {
  const [pasted, setPasted] = useState('');
  const [preview, setPreview] = useState([]);
  const [result, setResult] = useState(null);
  const [importing, setImporting] = useState(false);

  function handleParse() {
    const parsed = parsePastedText(pasted);
    setPreview(parsed);
    setResult(null);
  }

  async function handleImport() {
    if (preview.length === 0) return;
    setImporting(true);
    let created = 0, merged = 0, skipped = 0, errors = 0;

    for (const lead of preview) {
      try {
        const { action } = await upsertLead(lead);
        if (action === 'created') created++;
        else if (action === 'merged') merged++;
        else skipped++;
      } catch { errors++; }
    }

    setResult({ created, merged, skipped, errors });
    setPreview([]);
    setPasted('');
    setImporting(false);
  }

  return (
    <div>
      <div className="page-header">
        <div className="page-eyebrow">▸ data / import</div>
        <div className="page-title">import</div>
        <div className="page-divider" />
      </div>

      <div className="form-section">
        <div className="form-section-title">paste import</div>
        <p style={{ fontSize: 12, color: 'var(--smoke)', marginBottom: '0.75rem', lineHeight: 1.7 }}>
          open google maps, search a business type + area, copy the text and paste below. separate businesses with a blank line.
        </p>
        <textarea
          className="import-paste"
          placeholder={"Sydney Physio Group\nPhysiotherapy\n02 9000 1234\nhttps://sydneyphysio.com.au\n4.8 (96)\n\nNorth Shore Chiro\nChiropractor\n02 9111 2222\n..."}
          value={pasted}
          onChange={e => setPasted(e.target.value)}
        />
        <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
          <button className="btn" onClick={handleParse} disabled={!pasted.trim()}>parse</button>
          {preview.length > 0 && (
            <button className="btn btn-primary" onClick={handleImport} disabled={importing}>
              {importing ? 'importing...' : `import ${preview.length} ▸`}
            </button>
          )}
        </div>

        {preview.length > 0 && (
          <div style={{ marginTop: '1rem' }}>
            <div style={{ fontSize: 9, color: 'var(--smoke)', letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: 8 }}>
              preview — {preview.length} parsed
            </div>
            {preview.map((l, i) => (
              <div key={i} style={{ padding: '8px 0', borderBottom: '0.5px solid var(--hairline)', fontSize: 12 }}>
                <span style={{ color: 'var(--paper)' }}>{l.businessName}</span>
                <span style={{ color: 'var(--smoke)', marginLeft: 12 }}>
                  {[l.category, l.phone, l.suburb].filter(Boolean).join(' · ')}
                </span>
              </div>
            ))}
          </div>
        )}

        {result && (
          <div className={`import-result ${result.errors > 0 ? 'import-warn' : 'import-ok'}`}>
            created {result.created} · merged {result.merged} · skipped {result.skipped}
            {result.errors > 0 && ` · ${result.errors} errors`}
          </div>
        )}
      </div>

      <div className="form-section">
        <div className="form-section-title">scraper agent</div>
        <p style={{ fontSize: 12, color: 'var(--smoke)', lineHeight: 1.7, marginBottom: '0.75rem' }}>
          the scraper runs on your machine and pushes results directly to firestore.
        </p>
        <div className="cmd-box">
          <code>python agent.py --query "physio" --location "Sydney NSW" --limit 50</code>
        </div>
      </div>
    </div>
  );
}
